import { useEffect } from 'react'

/**
 * @callback clickOutsideCb
 * @return {void}
 */

/**
 * custom hook. Calling cb if the click occurred outside the provided elements
 * @param {HTMLElement[]} elements
 * @param {clickOutsideCb} cb
 * @returns {Boolean}
 */
export function useOutsideClick (elements, cb) {
  useEffect(() => {
    function handleClickOutside (e) {
      const isClickedOutsideOfElements = elements.every(
        (el) => el !== null && !el.contains(e.target),
      )
      if (isClickedOutsideOfElements) {
        cb()
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [cb, elements])
}
